<script setup>
import { ref, onMounted, watch, watchEffect, reactive } from "vue";
import axios from "axios"; /*cmdでのインストール未完了*/
import { useStore } from "@/store/authStore";
import { useRoute } from "vue-router";
import RegistrationModal from "../components/RegistrationModal.vue";
import EditModal from "../components/EditModal.vue";
import { useApiStore } from "@/store/apiStore";
import { Modal } from "bootstrap";
const apiStore = useApiStore();
//import bootstrap from 'bootstrap';

/*
onMounted(() => {
  const modalElement = document.getElementById('registModal');
  const modalInstance = new bootstrap.Modal(modalElement);
  const regist = () =>{
    modalInstance.show();
  }
  // 任意: モーダルの表示や非表示などの操作が必要な場合、modalInstance を使って行います。
  // modalInstance.show();
});*/

const store = useStore();
const tokenHeaders = store.getTokenHeaders;

const route = useRoute();

/*初期値*/
const getApiUrl = apiStore.getUsersPath; //`http://boatrace-prod-public-alb-958219121.ap-northeast-1.elb.amazonaws.com/api/v1/users`
const getRolesApiUrl = apiStore.getRolesPath; //`http://boatrace-prod-public-alb-958219121.ap-northeast-1.elb.amazonaws.com/api/v1/roles`
const users = ref([
  {
    id: "",
    userId: "",
    name: "",
    journalistName: "",
    publicationOrder: "",
    invalid: "",
    roles: [],
  },
]);

const roles = ref([
  {
    id: 0,
    name: "",
  },
]);

//users.value = mockResults;

//MyModalで使用する変数を定義
let myModal1 = false;
let myModal2 = false;

//user情報取得
const getUser = async () => {
  try {
    // ユーザーのURLと適切なヘッダー情報を指定
    const response = await axios.get(getApiUrl, tokenHeaders);

    if (response.status === 200) {
      console.log("検索成功");
      console.log(response.data);
      users.value = response.data;
    }

    //ロール取得
    watchEffect(async () => {
      const response2 = await axios.get(getRolesApiUrl, tokenHeaders);
      if (response2.status === 200) {
        console.log("ロール検索成功");
        console.log(response2.data);
        roles.value = response2.data;
      }
    });
  } catch (error) {
    console.error(error);
    alert(error.message);
    console.error("Axios Error:", error);

    if (!error.response) {
      alert("原因不明のエラー");
      return;
    } // エラーオブジェクトからステータスコードを取得
    const statusCode = error.response && error.response.status;
    // ステータスコードに応じたエラーハンドリング
    if (statusCode) {
      switch (statusCode) {
        case 400:
          alert("Bad Request - リクエストが不正です");
          break;
        case 401:
          alert("Unauthorized - 認証エラーです");
          break;
        case 403:
          alert("Forbidden - アクセス権限がありません");
          break;
        case 404:
          alert("Not Found - リソースが見つかりません");
          break;
        case 500:
          alert("Internal Server Error - サーバーエラーです");
          break;
        default:
          alert(`Unknown error - ステータスコード: ${statusCode}`);
      }
    } else {
      alert("エラーが発生しましたが、ステータスコードを取得できませんでした");
    }
  }
};
/**
 * 監視対象の`route.params`が変更された場合に実行
 */
watch(
  () => route.params,
  async () => {
    try {
      await getUser();
    } catch (error) {
      console.error(error);
    }
  },
  { immediate: true, deep: true }
); //即時実行と深い監視
//チェックボックスのリアクティブ変数
const checkboxInvalid = ref(false);
const checkboxrole = ref(false);

// チェックボックスの値を監視
watch(checkboxInvalid, (newValue) => {
  users.value.invalid = newValue ? 1 : 0;
});

watch(checkboxrole, (newValue) => {
  users.value.role = newValue ? 1 : 0;
});

//キャンセルボタン押下
const cancel = async () => {
  console.log("キャンセルされました");
  // ここにキャンセルの処理を追加する
};

//新規登録処理
const apiUrl = apiStore.getUsersPath; //'http://boatrace-prod-public-alb-958219121.ap-northeast-1.elb.amazonaws.com/api/v1/users';

onMounted(() => {
  myModal1 = new Modal(document.getElementById("registModal"));
  myModal2 = new Modal(document.getElementById("exampleModal"));
});
const regist = async (obj) => {
  console.log(obj);
  let senduserData = Object.assign({}, obj);

  console.log("新規登録開始");
  try {
    const response = await axios.post(apiUrl, senduserData, tokenHeaders);

    if (response.status == 200) {
      console.log(response.data);

      //users.value = reponse.data;
      handleRegistrationSuccess(response.data);
      myModal1.hide();
      await getUser();
      alert("ユーザー登録が完了しました。");
    } else if (response.status == 409) {
      alert("重複しています");
    }
  } catch (error) {
    if (error.response && error.response.status == 409) {
      alert("既に登録されているユーザーIDです。ユーザーIDをご確認ください。");
    }
    console.error("Registration error:", error);

    // 登録エラー時の処理
  }

  function handleRegistrationSuccess(data) {
    console.log("User registered successfully:", data);

    // 登録成功時の処理
    //closeRegistrationModal(); // ダイアログを閉じる
    // ユーザーデータの再読み込みなどの処理を行うかもしれません
  }
};

//編集処理apEditiUrl1
const apEditiUrl1 = apiStore.getUsersPathForId; //'http://boatrace-prod-public-alb-958219121.ap-northeast-1.elb.amazonaws.com/api/v1/users/';

const editRegist = async (obj) => {
  console.log(obj);
  console.log(obj.id);
  let edituserData = Object.assign({}, obj);
  console.log(edituserData);

  console.log("編集登録開始");
  try {
    const putUrl = apEditiUrl1(obj.id);
    //`${apEditiUrl1}${obj.id}`;
    const response = await axios.put(putUrl, edituserData, tokenHeaders);

    if (response.status == 200) {
      console.log(response.data);
      //users.value = reponse.data;
      handleRegistrationSuccess(response.data);
      myModal2.hide();
      await getUser();
      alert("ユーザー情報を更新しました。");
    }
  } catch (error) {
    console.error("Registration error:", error);
    // 登録エラー時の処理
  }

  function handleRegistrationSuccess(data) {
    console.log("User edit successfully:", data);
    // 登録成功時の処理
    //closeRegistrationModal(); // ダイアログを閉じる
    // ユーザーデータの再読み込みなどの処理を行うかもしれません
  }
};

const dialogArg = reactive({
  userId: "",
});

//dialogargオブジェクトのプロパティを更新し、変更がトリガーされて再描写される
//引数argsを受け取る関数
function userInfo(arg) {
  console.log(arg);
  //argオブジェクトをdialogArgにコピー
  Object.assign(dialogArg, arg);
  console.log(dialogArg);

  myModal2.show();
}
</script>

<!--
<script>
export default {
    components: {
        'registration-modal': RegistrationModal,
    },
    methods: {
        showRegistrationModal() {
            // Code to show the modal here
        },
    },
}
</script>-->

<template>
  <div>
    <div class="d-flex justify-content-between col-3 mt-1 mb-2">
      <button class="submit_button" @click="myModal1.show()">新規登録</button>
    </div>

    <!-- Use the RegistrationModal component here -->
    <RegistrationModal :roles="roles" @cancel="cancel" @regist="regist" />
    <!--<registration-modal></registration-modal>-->
    <EditModal
      :roles="roles"
      :dialogItem="dialogArg"
      @editRegist="editRegist"
      @editCancel="cancel"
    />
  </div>

  <table class="result_list">
    <thead>
      <tr class="result_title">
        <td class="centered1"></td>
        <td class="centered" style="text-align: center">ユーザーID</td>
        <td class="centered" style="text-align: center">氏名</td>
        <td class="centered" style="text-align: center">記者名</td>
        <td class="centered1" style="text-align: center">掲載優先順</td>
        <td class="centered1" style="text-align: center">無効フラグ</td>
        <td class="centered" style="text-align: center">役割</td>
      </tr>
    </thead>
    <tbody>
      <tr v-for="user in users" :key="user.id">
        <td>
          <button class="submit_button" v-on:click="userInfo(user)">
            編集
          </button>
        </td>
        <!--to="ダイアログのURL${user.id}`"-->
        <!--<button class="submit_button" v-on:click="regist" data-bs-toggle="modal" data-bs-target="#exampleModal">編集</button>-->
        <td>{{ user.userId }}</td>
        <td>{{ user.name }}</td>
        <td>{{ user.journalistName }}</td>
        <td>{{ user.publicationOrder }}</td>
        <td>
          <input disabled type="checkbox" :checked="user.invalid" />
          <span v-if="user.invalid">無効</span>
        </td>
        <td>
          <div>
            <div class="checkbox-group">
              <div v-for="role in roles" :key="role.id">
                <input
                  disabled
                  :id="`role-${role.id}`"
                  type="checkbox"
                  :value="role.id"
                  v-model="user.roles"
                />
                <label :for="`role-${role.id}`">{{ role.name }}</label>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped>
@media (prefers-color-scheme: dark) {
  /* ダークモード時のスタイリング */
  /**偶数行のセルに色をつける */
  .result_list tbody tr:nth-child(odd) {
    background-color: #3c3c3c !important;
  }
  /**罫線の色を白に変更 */
  .result_list th,
  .result_list td {
    padding: 8px;
    border: 1px solid #efefef !important;
    text-align: left;
    white-space: nowrap; /* テキストが折り返されないようにする */
    overflow: hidden; /* オーバーフローした内容を隠す */
    text-overflow: ellipsis; /* オーバーフローした部分を省略記号で表示 */
  }

  /*タイトルの背景色をネイビーに変更 */
  .result_title td {
    background-color: #00008b;
  }
}
/**奇数行のセルに色をつける */
.result_list tbody tr:nth-child(odd) {
  background-color: #efefef;
}

/**偶数行のセルに色をつける
.result_list tbody tr:nth-child(even) {
  background-color: #efefef;
} */

/* 通常のスタイル */
.checkbox-group {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-item {
  flex-basis: calc(50% - 10px); /* 2列にするための柔軟な幅設定 */
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

/* 画面幅が600px以下の場合のスタイル（例） */
@media (max-width: 600px) {
  .checkbox-group {
    flex-direction: column;
  }

  .checkbox-item {
    flex-basis: 80%;
  }
}
table,
th,
td {
  border-collapse: collapse;
  padding: 0.3rem;
}

/*編集ボタン・無効フラグ・掲載優先順のセル幅調整 */
td.centered1 {
  width: 100px;
}

/* 各セルのスタイル */
.result_list th,
.result_list td {
  padding: 8px;
  border: 1px solid #212529;
  text-align: left;
  white-space: nowrap; /* テキストが折り返されないようにする */
  overflow: hidden; /* オーバーフローした内容を隠す */
  text-overflow: ellipsis; /* オーバーフローした部分を省略記号で表示 */
}

.result_list td.publicationOrder,
.result_list td.invalid {
  max-width: 30px; /* 適切な幅に調整してください */
}
.result_title {
  text-align: center; /* 全体をセンターに配置 */
}

.centered {
  text-align: center; /* セル内のテキストをセンターに配置 */
}
</style>
